import { authGet, authPut } from '../../utils/authFetch';
import { wmServerAddress } from '../../common/MetaSetting';
import { fetchHttpResponseHandler, fetchHttpExceptionHandler } from '../../util/UtilFunction';
import { ApiShareSyncRequest, MemoShareSyncResponse, ApiFetchResponse } from '../../model/ApiShapes';
import { UIShareStatus } from '../../model/UiShapes';
import { apiShareStatusToUIShareStatus } from '../../model/DataConverters';

export function fetchMemoShares(): Promise<UIShareStatus[]> {
  return authGet(`${wmServerAddress}/memoShare/memos`)
    .then((response: any) => fetchHttpResponseHandler(response))
    .then((response) => response.content || [])
    .catch(fetchHttpExceptionHandler);
}

export function fetchMemoShare(memoId: string): Promise<UIShareStatus | null> {
  return authGet(`${wmServerAddress}/memoShare/memo/${memoId}`)
    .then((response: any) => fetchHttpResponseHandler(response))
    .then((response) => {
      if (response?.content) {
        return apiShareStatusToUIShareStatus(response.content);
      }
      return null;
    })
    .catch(() => {
      return null;
    });
}

export function remoteMemoShareSync(memo: UIShareStatus): Promise<MemoShareSyncResponse> {
  const apiShareSyncRequest: ApiShareSyncRequest = {
    syncType: 0,
    guid: memo.guid,
    sourceShare: memo
  };

  return authPut(`${wmServerAddress}/memoShare/memo/sync`, {
    body: JSON.stringify(apiShareSyncRequest)
  })
    .then((response: any) => fetchHttpResponseHandler(response))
    .then((response: ApiFetchResponse<MemoShareSyncResponse>) => {
      if (response.content && typeof response.content === 'object') {
        return response.content;
      }
      throw new Error('Invalid response format from memoShare sync API');
    })
    .catch((error) => {
      throw error;
    });
}



// Query keys for Memo Share
export const memoShareKeys = {
  all: ['memo-shares'] as const,
  lists: () => [...memoShareKeys.all, 'list'] as const,
  list: () => [...memoShareKeys.lists(), {}] as const,
  shares: () => [...memoShareKeys.all, 'share'] as const,
  share: (id: string) => [...memoShareKeys.shares(), id] as const,
};

